/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';

import styles from './Content.module.css';

interface ContentStreetStudioProps {
  streetName: string;
  cityName: string;
}

export const ContentStreetStudio = ({
  streetName,
  cityName,
}: ContentStreetStudioProps) => {
  const { locale } = useIntl();

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography
        variant="h1"
        className={styles.title}
      >{`Studio Apartments for Rent in ${streetName}, ${cityName}`}</Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Searching for a studio apartment in ${streetName}? With Kamernet, rent a
            studio in ${streetName} that best matches your needs. Studios in ${streetName} are very
            much in demand in ${cityName} due to easy maintenance, cheaper utilities and
            affordable rent. You can browse through our list of ${streetName} studio
            apartments and find more information about their services and
            amenities. If you are on the lookout to rent a studio in ${streetName}, then
            you will find a range of affordable options to choose from. If you
            don't know where to find a studio to rent in ${streetName} then look no
            further, as Kamernet is the best website to find studio apartments
            in ${streetName} from both housing agencies and homeowners.`}
      </Typography>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography
        variant="h1"
        className={styles.title}
      >{`Studio te Huur ${streetName}, ${cityName}`}</Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Op zoek naar een studio appartement in ${streetName}? Bij Kamernet vind je een
            studio te huur ${streetName} die het beste bij jou past. Studio-appartementen
            in ${streetName} zijn erg in trek in ${cityName} vanwege eenvoudig onderhoud,
            goedkopere nutsvoorzieningen en betaalbare huur. U kunt door onze
            lijst met ${streetName} studio-appartementen bladeren en meer informatie
            vinden over hun diensten en voorzieningen. Als je op zoek bent naar
            een studio in ${streetName}, dan vind je een scala aan betaalbare opties om
            uit te kiezen. Als je niet weet waar je een studio te huur kunt
            vinden in ${streetName}, zoek dan niet verder, want Kamernet is de beste
            website om studio's in ${streetName} te vinden van zowel makelaars als
            huiseigenaren.`}
      </Typography>
    </React.Fragment>
  );
};
